import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getOcpcTransFeed(data) {
    return request.get(`/${platform}/baidu/get_ocpc_trans_feed`,data)
}

export function getImageList(data) {
    return request.get(`/${platform}/baidu/get_image_list`,data)
}

export function getVideoList(data) {
    return request.get(`/${platform}/baidu/get_video_list`,data)
}
